<template>
  <b-card class="p-2 h-20">

   <div class="d-flex flex-column h-100 justify-content-center"  style="min-height: 180px;">
      <b-button 
        :disabled="!canManage"
        variant="secondary" 
        class="mb-2" 
        block
        v-b-tooltip.hover
        @click="$emit('open-add-modal')"
        title="Adicionar um item individual à blacklist"
      >
        Inclusão Única
      </b-button>

       <b-button 
      :disabled="!canManage"
        variant="primary" 
        class="mb-2" 
        block
        @click="$emit('open-bulk-modal')"
        v-b-tooltip.hover
        title="Enviar um arquivo para inclusão em lote"
      >
        <i class="fas fa-upload mr-2"></i>
        Inclusão em Lote
      </b-button> 

      <b-button 
        :disabled="!canManage"
        variant="danger" 
        block
        @click="$emit('open-delete-modal')"
        v-b-tooltip.hover
        title="Remover um item individual da blacklist"
      >
        Exclusão Única
      </b-button>
    </div>

  </b-card>
</template>

<script>

import { BCard, BButton } from 'bootstrap-vue'

export default {
  props: {
  canManage: {
    type: Boolean,
    default: false
  }
},
  name: 'BlackListActions',
  components: {
    BCard,
    BButton
  }
}
</script>